import React from "react";
import Header from "./Header";
import SideNav from "./SideNav";
const MainLayout: React.FC<{
    searchValue?: string;
    onChange?: React.ChangeEventHandler<HTMLInputElement>;
    clearValChange?: () => void;  // Function to clear search value
    children: React.ReactNode;
    startDate?: Date;
    endDate?: Date;
    startDateOnChange?: (date: Date, event: React.SyntheticEvent<any, Event>) => void; // Adjust this line
    endDateOnChange?: (date: Date, event: React.SyntheticEvent<any, Event>) => void; // Adjust this line
    onSelectionChange?: (selectedChildren: any[]) => void; // Corrected type here
    showAllFilters?: boolean;
    formattedData?: any[];
    headers?: any[];
    exportPDF?: () => void;
    pageSize?: number


}> = ({
    searchValue,
    clearValChange,
    onChange,
    children,
    startDate,
    endDate,
    startDateOnChange,
    endDateOnChange,
    // onSelectionChange,
    showAllFilters,
    // formattedData = [],
    // headers = [],
    // exportPDF = () => { },
    // pageSize

}) => {
    return (
        <div className="d-flex">
            <SideNav />
            <main className="main-content position-relative border-radius-lg w-100" >
                <Header
                    // pageSize={pageSize as number}
                    showAllFilters={showAllFilters as boolean}
                    searchValue={searchValue ?? ""}
                    clearValChange={clearValChange ? clearValChange : () => console.log("not passed from props")}
                    searchOnChange={onChange ? onChange : () => console.log("not passed from props")}
                    startDate={startDate ?? new Date()}
                    endDate={endDate ?? new Date()}
                    startDateOnChange={startDateOnChange ? startDateOnChange : () => console.log("not passed from props")}
                    endDateOnChange={endDateOnChange ? endDateOnChange : () => console.log("not passed from props")}
                    // onSelectionChange={onSelectionChange ? onSelectionChange : () => console.log("not passed from props")}
                    // formattedData={formattedData}
                    // headers={headers}
                    // exportPDF={exportPDF}
                />
                <div className=" child_mainLayuot">
                    {children}

                    {/* <Footer></Footer> */}
                </div>
            </main>



        </div>

    )
}

export default MainLayout;